import "./project.css";
import ProjectCard from "./ProjectCard"
import React, {useEffect, useState } from 'react';
import { HTTP } from "../../api/http-common";
import { ArrowDownward } from "@material-ui/icons";


function Project() {
  const [activeFilter, setActiveFilter] = useState("all");
  const [loading, setLoading] = useState(true);
  

  const filters = [
    { id: "all", label: "Show all" },
    { id: "full_stack", label: "Full stack" },
    { id: "back_end", label: "Back end" },
    { id: "front_end", label: "Front end" },
    { id: "script", label: "Script" },
    { id: "ds", label: "Data Science" },
    // { id: "other", label: "Others" },
  ];

  let defaultData = [
    {
      id: 11,
      type: "back_end",
      title: "Food Delevery API",
      name: "Food Delevery API",
      project_photo_detail: [
            {
                image: "assets/project_image/burger.png",
            }
        ],
      live_url:null,  
      project_technology_detail: [
        {
            name: "Python",
        }
        ], 
      team_size: 7,
      start: "0",
      end: "10",   
      description:
      "This project is develop for online food delivery service. Customer can search food and order food and give the reviews and rating on different Restaurant and food.",
    },
    {
      id: 12,
      type: "back_end",
      title: "Online Shoping API",
      name: "Online Shoping API",
      live_url:null,      
      project_photo_detail: [
            {
                image: "assets/project_image/ecom_milk.png",
            }
        ],
      project_technology_detail: [
        {
            name: "Python",
        }
        ], 
      team_size: 7,
      start: "0",
      end: "10",  
      description: "This project is develop for online shoping service. Customer can search product and order product and give the reviews and rating on different Shops and product.",
    },
    {
      id: 13,
      type: "back_end",
      title: "Glasses shop API",
      name: "Glasses shop API",
      live_url:null,      
      project_photo_detail: [
            {
                image: "assets/project_image/glasses.png",
            }
        ],
      project_technology_detail: [
        {
            name: "Python",
        }
        ], 
      team_size: 7,
      start: "0",
      end: "10",  
      description: "This project is develoop for online glasses shoping service",
    },
    {
      id: 14,
      type: "back_end",
      title: "Music player API",
      name: "Music player API",
      live_url:null,    
      project_technology_detail: [
        {
            name: "Python",
        }
        ], 
      team_size: 7,
      start: "0",
      end: "10",    
      project_photo_detail: [
            {
                image: "assets/project_image/music1.png",
            }
        ],
      description: "This is an application based on search music and watch music and user can add music is the  favorite list and so on...",
    },
    {
      id: 15,
      type: "back_end",
      title: "Spotify music API",
      name: "Spotify music player API",
      live_url:null,
      project_technology_detail: [
        {
            name: "Python",
        }
        ], 
      team_size: 7,
      start: "0",
      end: "10",        
      project_photo_detail: [
            {
                image: "assets/project_image/music2.png",
            }
        ],
      description: "This is and music player app like Spotify user can play music and search music and add music in the favorite list .",
    },
    {
      id: 16,
      type: "back_end",
      title: "Pizza Delevery API",
      name: "Pizza Delevery API",
      live_url:null,
      project_technology_detail: [
        {
            name: "Python",
        }
        ], 
      team_size: 7,
      start: "0",
      end: "10",        
      project_photo_detail: [
            {
                image: "assets/project_image/pizza.png",
            }
        ],
      description: "This is an online Pizza Delevery App service Customer search and order different category pizza.",
    },

    {
      id: 17,
      type: "back_end",
      title: "M Akmal Dresses",
      name: "M Akmal Dresses",
      live_url:null,
      project_technology_detail: [
        {
            name: "Python",
        }
        ], 
      team_size: 7,
      start: "0",
      end: "10",        
      project_photo_detail: [
            {
                image: "assets/project_image/makmal.png",
            }
        ],
      description: "This is a Clothing based Website for manage buying and selling details on online and can search or filter details based on the required.",
    },
    // {
    //   id: 21,
    //   type: "back_end",
    //   title: "Music player App",
    //   name: "Music player app",
    //   live_url:null,
    //   project_technology_detail: [
    //     {
    //         name: "Python",
    //     }
    //     ], 
    //   team_size: 7,
    //   start: "0",
    //   end: "10",        
    //   project_photo_detail: [
    //         {
    //             image: "assets/project_image/music1.png",
    //         }
    //     ],
    //   description: "This is an application based on search music and watch music and user and add music is the favorite list and so on...",
    // },
    // {
    //   id: 22,
    //   type: "back_end",
    //   title: "Spotify music app",
    //   name: "Spotify music player app",
    //   live_url:null,      
    //   project_photo_detail: [
    //         {
    //             image: "assets/project_image/music2.png",
    //         }
    //     ],
    //   description: "This is and music player app like Spotify user can play music and search music and add music in the favorite list .",
    // },
    // {
    //   id: 23,
    //   type: "back_end",
    //   title: "Food Delivery App",
    //   name: "Food Delivery App",
    //   live_url:null,
    //   project_technology_detail: [
    //     {
    //         name: "Python",
    //     }
    //     ], 
    //   team_size: 7,
    //   start: "0",
    //   end: "10",        
    //   project_photo_detail: [
    //         {
    //             image: "assets/project_image/burger.png",
    //         }
    //     ],
    //   description:
    //   "This project is develop for online food delivery service. Customer can search food and order food and give the reviews and rating on different Restaurant and food.",
    // },
    {
      id: 24,
      type: "back_end",
      title: "Gym Management",
      name: "Student Management System",
      live_url:null,
      project_technology_detail: [
        {
            name: "Python",
        }
        ], 
      team_size: 7,
      start: "0",
      end: "10",        
      project_photo_detail: [
            {
                image: "assets/project_image/gym.PNG",
            }
        ],
      description:
      "The Project is a software designed to help the gym to keep the track of the day to day activities which take place in the gym. Project deals with an online system designed for management of customers,enquiries, and equipments, payment etc.",
    },
    {
      id: 25,
      type: "back_end",
      title: "ECommerce App",
      name: "ECommerce Management System",
      live_url:null,
      project_technology_detail: [
        {
            name: "Python",
        }
        ], 
      team_size: 7,
      start: "0",
      end: "10",        
      project_photo_detail: [
            {
                image: "assets/project_image/eshop.png",
            }
        ],
      description:
      "This is an ECommerce Management System is an online Dresses shoping service. Customer can search and add to cart product and order products through this systems.",
    },
    {
      id: 1,
      type: "back_end",
      title: "Hotel Management",
      name: "Hotel Management System",
      live_url:null,
      project_technology_detail: [
        {
            name: "Python",
        }
        ], 
      team_size: 7,
      start: "0",
      end: "10",        
      project_photo_detail: [
            {
                image: "assets/project_image/book.PNG",
            }
        ],
      description: "This is a Hotel management system is an online room booking system. Customer can search nearby availabe room in hotel and can book room on the based required.",
    },
    {
      id: 2,
      type: "front_end",
      title: "Game(Cat and Dog)",
      name: "Game",
      live_url:null,
      project_technology_detail: [
        {
            name: "Python",
        }
        ], 
      team_size: 7,
      start: "0",
      end: "10",        
      project_photo_detail: [
            {
                image: "assets/project_image/game.PNG",
            }
        ],
      description: "This is an animation based game cat and dog that can not colide to each others, Cat is jump or back to save from Dog.",
    },

    {
      id: 3,
      type: "front_end",
      title: "Social Media App",
      name: "Social Media App",
      live_url:null,
      project_technology_detail: [
        {
            name: "Python",
        }
        ], 
      team_size: 7,
      start: "0",
      end: "10",        
      project_photo_detail: [
            {
                image: "assets/project_image/media.png",
            }
        ],
      description: "Social Media App is a social app like facebook and instagram user can post like,share and comment on the post data.",
    },
    {
      id: 4,
      type: "front_end",
      title: "News API System",
      name: "News Management System",
      live_url:null,
      project_technology_detail: [
        {
            name: "Python",
        }
        ], 
      team_size: 7,
      start: "0",
      end: "10",        
      project_photo_detail: [
            {
                image: "assets/project_image/news.png",
            }
        ],
      description: "This is a News Management System, you can filter news with category wise and can read latest news with ariticles with infinite scroll bar through the help of news api.",
    },
    {
      id: 5,
      type: "front_end",
      title: "My Portfolio App",
      name: "My Portfolio Website",
      live_url:null,
      project_technology_detail: [
        {
            name: "Python",
        }
        ], 
      team_size: 7,
      start: "0",
      end: "10",        
      project_photo_detail: [
            {
                image: "assets/project_image/my_portfolio.png"
            }
        ],
      description: "This is my Portfolio Website, that is present infront of you  this is development in full responsive designed in react JS and Material UI.",
    },
  ];

  const [projectData, setProjectData] = useState(null);

  const filteredData =
    activeFilter === "all"
      ? projectData
      : projectData.filter((item) => item.type === activeFilter);


  useEffect(() => {

    let home_url = '/api/portfolio/project/'
    HTTP.get(home_url)
    .then(function (response) {
        console.log(response.status);

        if (response.status === 200 && response.data.results.length > 0) {
          setProjectData(response.data.results);
        } else {
          setProjectData(defaultData); // fallback if API returns empty
        }

        setLoading(false);

    })
    .catch(function (err) {
        console.log(err);
        setProjectData(defaultData); // fallback if API returns empty
        setLoading(false);
    });


  }, []); // 👈 empty array ensures this runs once on component mount


  if (loading) return <div className="text-center m-5"> <h3>Loading...</h3></div>;
      
  return (
    <div className="container" style={{ marginTop: "60px" }}>
      <p className="text-center contText">Our Works</p>
      <br />
      <p className="contp">
        Here my project works <ArrowDownward />
      </p>
      <br />

      {/* Filter Buttons */}
      <div className="myBtnContainer text-center">
        {filters.map((filter) => (
          <button
            key={filter.id}
            className={`btn p-2 m-2 filterBtn ${
              activeFilter === filter.id ? "active" : ""
            }`}
            onClick={() => setActiveFilter(filter.id)}
          >
            {filter.label}
          </button>
        ))}
      </div>

      {/* Project Cards */}
      <div className="row mt-5 text-center projectItems">
        {filteredData.map((item) => (
          <ProjectCard data={item} key={item.id} />
        ))}
      </div>
    </div>
  );
}

export default Project;
